import React from "react";
import classNames from "classnames/bind";
import styles from "./Grid.module.scss";
import { ColumnProps } from "./types";

const cx = classNames.bind(styles);

const Column = ({ variant = 24, children }: ColumnProps) => {
  return <div className={cx("column", `_${variant}`)}>{children}</div>;
};

export default Column;
